import React, { useContext } from "react";

import { Layout } from "../components/_layout";
import { Campaigns } from "../components/CampaignsModule";
import { Likes } from "../components/LikesModule";
import { Subscriptions } from "../components/SubscriptionsModule";
import { Profile } from "../components/ProfileModule";

import { IconButton } from "@material-ui/core";
import { FiMessageCircle } from "react-icons/fi";

import { Context as ViewsContext } from "../context/ViewsContext";

const RootViews = () => {
  const {
    state: { currentView }
  } = useContext(ViewsContext);

  const handleViews = () => {
    switch (currentView) {
      case 0:
        return <Campaigns />;
      case 1:
        return <Subscriptions />;
      case 2:
        return <Likes />;
      case 3:
        return <Profile />;
      default:
        return null;
    }
  };
  return (
    <Layout
      rightContainerChildren={
        <IconButton>
          <FiMessageCircle />
        </IconButton>
      }
    >
      {handleViews()}
    </Layout>
  );
};

export default RootViews;
